import axiosInstance from '../helpers/axiosInstance'

const base = warehouse_id => `${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouse_id}`

// Work shifts
export const fetchWorkShifts = async (warehouse_id, params = {}) => {
  const res = await axiosInstance.get(`${base(warehouse_id)}/work-shifts`, { params })
  return res.data
}

export const createWorkShift = async (warehouse_id, data) => {
  const res = await axiosInstance.post(`${base(warehouse_id)}/work-shifts`, data)
  return res.data
}

export const updateWorkShift = async (warehouse_id, id, data) => {
  const res = await axiosInstance.put(`${base(warehouse_id)}/work-shifts/${id}`, data)
  return res.data
}

// Warehouse operators
export const fetchWarehouseOperators = async (warehouse_id, params = {}) => {
  const res = await axiosInstance.get(`${base(warehouse_id)}/warehouse-operators`, { params })
  return res.data
}

export const createWarehouseOperator = async (warehouse_id, data) => {
  const res = await axiosInstance.post(`${base(warehouse_id)}/warehouse-operators`, data)
  return res.data
}

export const updateWarehouseOperator = async (warehouse_id, id, data) => {
  const res = await axiosInstance.put(`${base(warehouse_id)}/warehouse-operators/${id}`, data)
  return res.data
}

// An operator's dated assignment history, newest first.
export const fetchOperatorAssignments = async (warehouse_id, id) => {
  const res = await axiosInstance.get(`${base(warehouse_id)}/warehouse-operators/${id}/assignments`)
  return res.data
}

// Attendance
export const fetchShiftAttendance = async (warehouse_id, shift_id, params = {}) => {
  const res = await axiosInstance.get(`${base(warehouse_id)}/shifts/${shift_id}/attendance`, { params })
  return res.data
}

export const saveShiftAttendance = async (warehouse_id, shift_id, data) => {
  const res = await axiosInstance.put(`${base(warehouse_id)}/shifts/${shift_id}/attendance`, data)
  return res.data
}

// Operator rates
export const fetchOperatorRates = async (warehouse_id, params = {}) => {
  const res = await axiosInstance.get(`${base(warehouse_id)}/operator-rates`, { params })
  return res.data
}

export const createOperatorRate = async (warehouse_id, data) => {
  const res = await axiosInstance.post(`${base(warehouse_id)}/operator-rates`, data)
  return res.data
}

export const patchOperatorRate = async (warehouse_id, id, data) => {
  const res = await axiosInstance.patch(`${base(warehouse_id)}/operator-rates/${id}`, data)
  return res.data
}

// Operator costs
export const fetchOperatorCosts = async (warehouse_id, params = {}) => {
  const res = await axiosInstance.get(`${base(warehouse_id)}/operator-costs`, { params })
  return res.data
}

// User autocomplete for AssignOperator (existing endpoint, new usage)
export const searchWarehouseUsers = async (warehouse_id, params = {}) => {
  const res = await axiosInstance.get(`${base(warehouse_id)}/operators`, { params })
  return res.data
}

// Shift schedules (timeline periods)
export const fetchShiftSchedules = async (warehouse_id, params = {}) => {
  const res = await axiosInstance.get(`${base(warehouse_id)}/shift-schedules`, { params })
  return res.data
}

export const createShiftSchedule = async (warehouse_id, data) => {
  const res = await axiosInstance.post(`${base(warehouse_id)}/shift-schedules`, data)
  return res.data
}

export const updateShiftSchedule = async (warehouse_id, id, data) => {
  const res = await axiosInstance.put(`${base(warehouse_id)}/shift-schedules/${id}`, data)
  return res.data
}

export const deleteShiftSchedule = async (warehouse_id, id) => {
  const res = await axiosInstance.delete(`${base(warehouse_id)}/shift-schedules/${id}`)
  return res.data
}

export const fetchScheduleRoster = async (warehouse_id, schedule_id) => {
  const res = await axiosInstance.get(`${base(warehouse_id)}/shift-schedules/${schedule_id}/operators`)
  return res.data
}

export const saveScheduleRoster = async (warehouse_id, schedule_id, data) => {
  const res = await axiosInstance.put(`${base(warehouse_id)}/shift-schedules/${schedule_id}/operators`, data)
  return res.data
}
